import { useState } from 'react';

import { MainWrapper, InnerWrapper } from '../add-collaborator-flow/add-collaborator-flow.styled';
import RemoveCollaboratorSuccessScreen from './remove-collaborator-success-screen';
import RemoveCollaboratorConfirmationScreen, {
  RemoveCollaboratorSteps,
} from './remove-collaborator-confirmation-screen';

function RemoveCollaboratorFlow() {
  const [removeCollaboratorStep, setRemoveCollaboratorStep] = useState(RemoveCollaboratorSteps.CONFIRMATION);

  return (
    <MainWrapper>
      <InnerWrapper>
        {removeCollaboratorStep === RemoveCollaboratorSteps.VIEW_SUCCESS_MESSAGE ? (
          <RemoveCollaboratorSuccessScreen />
        ) : (
          <RemoveCollaboratorConfirmationScreen setStep={setRemoveCollaboratorStep} />
        )}
      </InnerWrapper>
    </MainWrapper>
  );
}
export default RemoveCollaboratorFlow;
